import React from "react";
import { motion } from "motion/react";
import ReactMarkdown from "react-markdown";

const Message = React.forwardRef(
  (
    {
      children,
      sender = "bot",
      layout = "position",
      initial = { opacity: 0, y: 10 },
      animate = { opacity: 1, y: 0 },
      transition = { duration: 0.2, ease: "easeOut" },
      className = "",
      onClick = null,
      ...props
    },
    ref
  ) => {
    // Pentatonic: suggestion pills get rounded-full, messages stay sharp
    const isSuggestion = sender === "suggestion";

    return (
      <motion.div
        layout={layout}
        initial={initial}
        animate={animate}
        transition={transition}
        ref={ref}
        onClick={onClick}
        className={`relative font-sans font-light ${
          sender === "user" ? "self-end" : sender === "bot" ? "self-start" : ""
        } max-w-[90%] ${onClick ? "cursor-pointer" : ""} ${className}`}
        {...props}
      >
        <div
          className={`relative block w-fit break-words leading-7 md:leading-relaxed ${
            sender === "bot"
              ? "bg-white py-2 px-4 border border-neutral-200"
              : sender === "user"
                ? "bg-penta-grey-light py-2 px-4 border border-neutral-200"
                : sender === "suggestion"
                  ? "bg-white px-5 py-2 border border-neutral-200 hover:border-penta-black transition-colors duration-200"
                  : ""
          } ${isSuggestion ? "rounded-full" : ""}`}
          style={{ maxWidth: "100%" }}
        >
          {/* Content */}
          <div className="relative z-0 text-penta-black">
            {typeof children === "string" ? (
              <ReactMarkdown className="prose max-w-none prose-p:my-1.5 prose-pre:my-1 prose-pre:p-2 prose-pre:bg-penta-grey-light prose-code:text-penta-blue prose-code:bg-penta-grey-light prose-code:px-1 prose-code:py-0.5 prose-code:before:content-none prose-code:after:content-none prose-ul:my-1.5 prose-li:my-0.5 prose-ul:pl-5 prose-ol:pl-5 prose-ul:list-disc prose-ol:list-decimal prose-ol:my-1.5 prose-li:pl-1 prose-li:marker:text-penta-black">
                {children}
              </ReactMarkdown>
            ) : (
              children
            )}
          </div>
        </div>
      </motion.div>
    );
  }
);

// Add a display name for debugging purposes
Message.displayName = "Message";

export default Message;
